/* ============================================================
   ALLYU — storefront interactions (Shopify AJAX cart)
   Adapted from the static site script.js. Vanilla JS, no deps.
   Every element lookup is guarded so the script never throws
   on pages where a given piece of UI is absent.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- config from theme.liquid (window.ALLYU) ---------- */
  var ALLYU = window.ALLYU || {};
  var ROUTES = ALLYU.routes || {};
  var STRINGS = ALLYU.strings || {};
  var FREE_SHIP = typeof STRINGS.freeShip === "number" ? STRINGS.freeShip : 12000; // cents
  var MONEY_FORMAT = ALLYU.money_format || "${{amount}}";

  /* ---------- tiny helpers ---------- */
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Shopify money formatting ---------- */
  function formatMoney(cents) {
    cents = typeof cents === "string" ? cents.replace(/[^0-9.-]/g, "") : cents;
    var value = "";
    var placeholderRe = /\{\{\s*(\w+)\s*\}\}/;
    var format = MONEY_FORMAT;
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;

    function number(num, precision, thousands, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      var amount = (num / 100).toFixed(precision);
      var parts = amount.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }

    switch (format.match(placeholderRe) ? format.match(placeholderRe)[1] : "amount") {
      case "amount":                       value = number(cents, 2, ",", "."); break;
      case "amount_no_decimals":           value = number(cents, 0, ",", "."); break;
      case "amount_with_comma_separator":  value = number(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = number(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = number(cents, 2, "'", "."); break;
      case "amount_with_space_separator":  value = number(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = number(cents, 0, " ", ","); break;
      default:                             value = number(cents, 2, ",", ".");
    }
    return format.replace(placeholderRe, value);
  }

  /* ============================================================
     ELEMENTS (all optional)
     ============================================================ */
  var header = $("#header");
  var cartEl = $("#cart");
  var overlay = $("#cartOverlay");
  var itemsEl = $("#cartItems");
  var countEl = $("#cartCount");
  var subtotalEl = $("#cartSubtotal");
  var shipWrap = $("#cartShip");
  var shipFill = $("#cartShipFill");
  var shipMsg = $("#cartShipMsg");
  var toastEl = $("#toast");
  var sizer = $("#sizer");
  var mobileMenu = $("#mobileMenu");
  var navToggle = $("#navToggle");

  /* ============================================================
     INTRO VEIL (animated logo reveal) — if present
     ============================================================ */
  (function () {
    var veil = $("#veil");
    if (!veil) return;
    var done = function () { veil.classList.add("is-done"); setTimeout(function () { if (veil.parentNode) veil.remove(); }, 900); };
    if (reduceMotion) { veil.remove(); return; }
    var t = setTimeout(done, 1950);
    veil.addEventListener("click", function () { clearTimeout(t); done(); });
  })();

  /* ============================================================
     OVERLAY scroll-lock + focus utilities
     ============================================================ */
  var lastFocused = null;
  var hasOpen = function (el) { return !!el && el.classList.contains("is-open"); };
  var anyOverlayOpen = function () { return hasOpen(cartEl) || hasOpen(sizer) || hasOpen(mobileMenu); };
  var syncScrollLock = function () { document.body.classList.toggle("no-scroll", anyOverlayOpen()); };
  var getFocusable = function (el) {
    if (!el) return [];
    return $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetWidth || n.offsetHeight || n === document.activeElement; });
  };
  var rememberFocus = function () { lastFocused = document.activeElement; };
  var restoreFocus = function () { if (!anyOverlayOpen() && lastFocused && lastFocused.focus) { lastFocused.focus(); lastFocused = null; } };

  /* ============================================================
     HEADER scroll state
     ============================================================ */
  if (header) {
    var onScroll = function () { header.classList.toggle("is-stuck", window.scrollY > 24); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     REVEAL on scroll
     ============================================================ */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    $$(".reveal").forEach(function (el) { io.observe(el); });
  } else { $$(".reveal").forEach(function (el) { el.classList.add("is-in"); }); }

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  var toggleMenu = function (open) {
    if (!mobileMenu) return;
    var willOpen = open != null ? open : !mobileMenu.classList.contains("is-open");
    if (willOpen) rememberFocus();
    mobileMenu.classList.toggle("is-open", willOpen);
    mobileMenu.setAttribute("aria-hidden", willOpen ? "false" : "true");
    if (navToggle) navToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
    syncScrollLock();
    if (willOpen) { var f = getFocusable(mobileMenu)[0]; if (f) f.focus(); } else restoreFocus();
  };
  if (navToggle) navToggle.addEventListener("click", function () { toggleMenu(); });
  $$("#mobileMenu a").forEach(function (a) { a.addEventListener("click", function () { toggleMenu(false); }); });

  /* ============================================================
     CART rendering (from Shopify cart object)
     ============================================================ */
  function renderCart(cart) {
    if (!cart) return;
    var count = cart.item_count || 0;
    if (countEl) { countEl.textContent = count; countEl.setAttribute("data-count", String(count)); }
    if (cartEl) cartEl.classList.toggle("is-empty", count === 0);

    if (itemsEl) {
      itemsEl.innerHTML = "";
      (cart.items || []).forEach(function (it) {
        var line = document.createElement("div");
        line.className = "cart-line";
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_120x$1$2") : "";
        var opts = (it.options_with_values || []).map(function (o) { return o.value; }).join(" · ");
        var meta = opts || (it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "");
        line.innerHTML =
          '<img class="cart-line__img" src="' + img + '" alt="" loading="lazy" />' +
          '<div><p class="cart-line__name">' + it.product_title + "</p>" +
          (meta ? '<p class="cart-line__meta">' + meta + "</p>" : "") +
          '<p class="cart-line__price">' + formatMoney(it.final_line_price) + "</p>" +
          '<div class="cart-line__qty">' +
            '<button type="button" data-act="dec" data-key="' + it.key + '" aria-label="Decrease quantity">−</button>' +
            "<span>" + it.quantity + "</span>" +
            '<button type="button" data-act="inc" data-key="' + it.key + '" aria-label="Increase quantity">+</button>' +
          "</div></div>" +
          '<button class="cart-line__remove" data-act="rm" data-key="' + it.key + '">Remove</button>';
        itemsEl.appendChild(line);
      });
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (shipFill) {
      var pct = FREE_SHIP > 0 ? Math.min(100, (cart.total_price / FREE_SHIP) * 100) : 100;
      shipFill.style.width = pct + "%";
    }
    if (shipWrap && shipMsg) {
      if (cart.total_price >= FREE_SHIP) {
        shipWrap.classList.add("is-free");
        shipMsg.textContent = "◆ You've unlocked complimentary shipping";
      } else {
        shipWrap.classList.remove("is-free");
        shipMsg.textContent = "Add " + formatMoney(FREE_SHIP - cart.total_price) + " for complimentary shipping";
      }
    }
  }

  /* ============================================================
     AJAX CART operations
     ============================================================ */
  function refreshCart() {
    if (!ROUTES.cart) return Promise.resolve(null);
    return fetch(ROUTES.cart, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  function addToCart(variantId, qty) {
    if (!ROUTES.cart_add || !variantId) return Promise.resolve(null);
    return fetch(ROUTES.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) { showToast((res.data && res.data.description) || "Unavailable", "", true); return null; }
        return refreshCart().then(function (cart) { return cart; });
      })
      .catch(function () { showToast("Something went wrong", "", true); return null; });
  }

  function changeLine(key, quantity) {
    if (!ROUTES.cart_change || !key) return Promise.resolve(null);
    return fetch(ROUTES.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  /* line qty +/- and remove (delegated) */
  if (itemsEl) {
    itemsEl.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-act]"); if (!btn) return;
      var key = btn.getAttribute("data-key"), act = btn.getAttribute("data-act");
      if (!key) return;
      var span = btn.parentNode ? btn.parentNode.querySelector("span") : null;
      var current = span ? parseInt(span.textContent, 10) || 0 : 0;
      if (act === "inc") changeLine(key, current + 1);
      else if (act === "dec") changeLine(key, Math.max(0, current - 1));
      else if (act === "rm") changeLine(key, 0);
    });
  }

  /* ============================================================
     CART drawer open/close
     ============================================================ */
  var openCart = function () {
    if (!cartEl) return;
    rememberFocus(); cartEl.inert = false;
    cartEl.classList.add("is-open");
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add("is-open"); }); }
    cartEl.setAttribute("aria-hidden", "false"); syncScrollLock();
    var c = $("#cartClose"); if (c) c.focus();
  };
  var closeCart = function () {
    if (!cartEl) return;
    cartEl.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    cartEl.setAttribute("aria-hidden", "true"); cartEl.inert = true;
    syncScrollLock(); restoreFocus();
    if (overlay) setTimeout(function () { overlay.hidden = true; }, 450);
  };
  var cartBtn = $("#cartBtn"); if (cartBtn) cartBtn.addEventListener("click", openCart);
  var cartClose = $("#cartClose"); if (cartClose) cartClose.addEventListener("click", closeCart);
  if (overlay) overlay.addEventListener("click", closeCart);
  var cartShop = $("#cartShop"); if (cartShop) cartShop.addEventListener("click", function () { closeCart(); });
  var cartCheckout = $("#cartCheckout");
  if (cartCheckout) cartCheckout.addEventListener("click", function () { window.location.href = "/checkout"; });

  /* ============================================================
     SIZE PICKER (variant-aware)
     ============================================================ */
  var sizerName = $("#sizerName"), sizerZh = $("#sizerZh"), sizerSizes = $("#sizerSizes"), sizerAdd = $("#sizerAdd");
  var sizerClose = $("#sizerClose");
  var pending = null; // { variantId, busy }

  function parseVariants(card) {
    var raw = card.getAttribute("data-variants");
    if (!raw) return [];
    try { return JSON.parse(raw) || []; } catch (e) { return []; }
  }

  var openSizer = function (card) {
    if (!sizer || !sizerSizes) return;
    rememberFocus();
    pending = { variantId: null, busy: false };
    var name = card.getAttribute("data-name") || "";
    var zh = (card.querySelector(".card__zh") || {}).textContent || "";
    if (sizerName) sizerName.textContent = name;
    if (sizerZh) sizerZh.textContent = zh || "";

    sizerSizes.innerHTML = "";
    var variants = parseVariants(card);
    variants.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = v.title;
      if (v.available === false) { b.disabled = true; b.classList.add("is-soldout"); }
      b.addEventListener("click", function () {
        if (b.disabled) return;
        $$("button", sizerSizes).forEach(function (x) { x.classList.remove("is-selected"); });
        b.classList.add("is-selected");
        pending.variantId = v.id;
        if (sizerAdd) sizerAdd.disabled = false;
      });
      sizerSizes.appendChild(b);
    });

    if (sizerAdd) sizerAdd.disabled = true;
    sizer.classList.add("is-open"); sizer.setAttribute("aria-hidden", "false");
    syncScrollLock();
    if (sizerClose) sizerClose.focus();
  };
  var closeSizer = function () {
    if (!sizer) return;
    sizer.classList.remove("is-open"); sizer.setAttribute("aria-hidden", "true");
    syncScrollLock(); restoreFocus(); pending = null;
  };
  if (sizerClose) sizerClose.addEventListener("click", closeSizer);
  if (sizer) sizer.addEventListener("click", function (e) { if (e.target === sizer) closeSizer(); });
  if (sizerAdd) sizerAdd.addEventListener("click", function () {
    if (!pending || !pending.variantId || pending.busy) return;
    pending.busy = true; sizerAdd.disabled = true;
    var name = sizerName ? sizerName.textContent : "";
    addToCart(pending.variantId, 1).then(function (cart) {
      closeSizer();
      if (cart) { showToast(name, ""); openCart(); }
    });
  });

  /* wire product cards: quick add + hover-flip to garment back */
  $$(".card").forEach(function (card) {
    var quick = $(".card__quick", card);
    if (quick) quick.addEventListener("click", function () { openSizer(card); });

    var media = $(".card__media", card);
    if (media) {
      var showBack = function () { card.classList.add("show-back"); };
      var hideBack = function () { card.classList.remove("show-back"); };
      media.addEventListener("pointerdown", showBack);
      media.addEventListener("pointerup", hideBack);
      media.addEventListener("pointerleave", hideBack);
      media.addEventListener("pointercancel", hideBack);
    }
  });

  /* ============================================================
     PRODUCT PAGE — variant radios -> hidden input + AJAX form
     ============================================================ */
  (function () {
    var form = $('form[action*="/cart/add"]') || $("#product-form") || $("[data-product-form]");
    var variantInput = $("#ProductVariantId");
    var radios = $$('input[name="options[Size]"], input[data-variant-id], .product-size input[type="radio"]');

    // Sync hidden variant id when a size radio changes.
    function syncVariant(radio) {
      if (!variantInput || !radio) return;
      var id = radio.getAttribute("data-variant-id") || radio.value;
      if (id) variantInput.value = id;
    }
    radios.forEach(function (radio) {
      radio.addEventListener("change", function () { if (radio.checked) syncVariant(radio); });
      if (radio.checked) syncVariant(radio);
    });

    if (!form) return;
    form.addEventListener("submit", function (e) {
      // Intercept and AJAX-add (preferred). Fall back to native submit on error.
      if (!ROUTES.cart_add) return;
      var id = variantInput && variantInput.value;
      if (!id) {
        var checked = form.querySelector('input[type="radio"]:checked[data-variant-id], input[type="radio"]:checked[name^="options"]');
        if (checked) id = checked.getAttribute("data-variant-id") || checked.value;
      }
      if (!id) {
        var sel = form.querySelector('select[name="id"], [name="id"]');
        if (sel) id = sel.value;
      }
      if (!id) return; // let the browser submit normally
      e.preventDefault();
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      var pname = (document.querySelector(".product__title, .product-title, h1") || {}).textContent || "";
      addToCart(id, qty).then(function (cart) {
        if (submitBtn) submitBtn.disabled = false;
        if (cart) { showToast(pname.trim(), ""); openCart(); }
      });
    });
  })();

  /* ============================================================
     TOAST
     ============================================================ */
  var toastTimer;
  function showToast(name, meta, plain) {
    if (!toastEl) return;
    var msg = plain ? (name || "Demo storefront.") : (STRINGS.added || "Added") + " · " + name + (meta ? " (" + meta + ")" : "");
    var msgEl = toastEl.querySelector(".toast__msg");
    if (msgEl) { msgEl.textContent = msg; }
    else { toastEl.innerHTML = '<span class="toast__seal">AY</span><span>' + msg + "</span>"; }
    toastEl.classList.add("is-show"); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove("is-show"); }, 3200);
  }

  /* ============================================================
     NEWSLETTER (client-side validation hint only;
     the real Shopify {% form 'customer' %} still submits)
     ============================================================ */
  var newsForm = $("#newsForm"), newsMsg = $("#newsMsg");
  if (newsForm && newsMsg && !newsForm.getAttribute("action")) {
    newsForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var field = newsForm.querySelector('[name="email"], [type="email"]');
      var ok = field && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim());
      if (!ok) { newsMsg.style.color = "var(--crimson)"; newsMsg.textContent = "Please enter a valid email."; return; }
      newsMsg.style.color = "var(--chrome)"; newsMsg.textContent = "Welcome. Walk your path."; newsForm.reset();
    });
  }

  /* ============================================================
     KEYS — Escape + Tab trap
     ============================================================ */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      if (hasOpen(sizer)) closeSizer();
      else if (hasOpen(cartEl)) closeCart();
      else if (hasOpen(mobileMenu)) toggleMenu(false);
      return;
    }
    if (e.key === "Tab") {
      var surface = hasOpen(sizer) ? (sizer.querySelector(".sizer__panel") || sizer)
                  : hasOpen(cartEl) ? cartEl
                  : hasOpen(mobileMenu) ? mobileMenu : null;
      if (!surface) return;
      var f = getFocusable(surface); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ============================================================
     INIT
     ============================================================ */
  var yr = $("#year"); if (yr) yr.textContent = new Date().getFullYear();
  if (cartEl) cartEl.inert = true;
  refreshCart();

  /* expose a tiny API for other sections if needed */
  window.ALLYU = window.ALLYU || {};
  window.ALLYU.addToCart = addToCart;
  window.ALLYU.refreshCart = refreshCart;
  window.ALLYU.openCart = openCart;
})();
